import classNames from 'classnames';
import { compose, map } from 'lodash/fp';
import { useAsync } from 'react-async-hook';
import { mapProps } from '../../../hoc/recompose';
import { withData } from '../../../hoc/withData';
import { useAppContext } from '../../../hooks/useAppContext';
import useLocation from '../../../hooks/useLocation';
import { prependAppPath } from '../../../services/Url';
import { useEapState } from '../../Admin/EarlyAccessProgram/useEapState';
import { PureNavLink } from './PureNavLink';
import { links } from './links';
import { toView } from './service';
import styles from './style.m.less';

const withStatusLabel = C => props => {
    const { user } = useAppContext();
    const { getStatusLabel } = props;
    const { result: statusLabel } = useAsync(() => getStatusLabel?.(user) || Promise.resolve(), [getStatusLabel, user]);
    return <C {...props} statusLabel={statusLabel} />;
};

const withSubscriber = C =>
    compose(
        withData({
            observe: {
                notification: props => props.notifier.observe(),
            },
            pendingComponent: C, // While pending, show component without the notification
            errorComponent: C, // If error happens for some reason, pretend that all is fine
        }),
        mapProps(props => ({
            ...props,
            notification: props.notifier.toNotification(props.notification),
        })),
        withStatusLabel
    )(C);

function BaseNavigation({ filteredLinks }) {
    let i = 0;
    return (
        <nav role="navigation">
            {map(
                group => (
                    <Group key={i++} className={group.className}>
                        {map(link => {
                            const NavLink = link.notifier ? withSubscriber(PureNavLink) : withStatusLabel(PureNavLink);
                            return <NavLink {...link} key={link.route + JSON.stringify(link.routeSearchParams)} />;
                        }, group.links)}
                    </Group>
                ),
                filteredLinks
            )}
        </nav>
    );
}

function Group({ children, className }) {
    return (
        <ul role="presentation" className={classNames(styles.group, className)}>
            {children}
        </ul>
    );
}

export default function PageNavigation() {
    const appContext = useAppContext();
    const { pathname } = useLocation();
    const [eapState] = useEapState();

    return (
        <div className={styles.navContainer}>
            <BaseNavigation filteredLinks={toView(links(eapState), appContext.user, prependAppPath(pathname))} />
        </div>
    );
}
